import {
  Component,
  ComponentInterface,
  Element,
  Listen,
  Prop,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-accordion',
  shadow: false,
})
export class UiAccordion implements ComponentInterface {
  @Element() el: HTMLElement;

  /**
   * Close all inactive accordions when opening a new one.
   */
  @Prop({ attribute: 'auto-close' }) autoClose: boolean;

  panels: HTMLUiAccordionPanelElement[];

  componentWillLoad() {
    // FIXME: lazy loading disabled due to sizing issues --> see readme.md
    const images = [].slice.call(this.el.querySelectorAll('ui-image'));
    images.forEach((element) => {
      element.setAttribute('lazy-loading', 'auto');
    });

    this.panels = [].slice.call(this.el.children);
  }

  componentDidLoad() {
    this.panels = [].slice.call(this.el.querySelectorAll('ui-accordion-panel'));
  }

  closePanel(panel: HTMLUiAccordionPanelElement) {
    panel.close();
  }

  @Listen('panelClick')
  onPanelClick(e) {
    const eventTarget = e.detail as any;

    if (this.panels[0].localName === 'slot') {
      // TODO refactor: remove cms logic from core component
      this.panels = eventTarget.parentElement
        .closest('ui-cms-accordion')
        .querySelectorAll('ui-accordion-panel');
    }
    if (this.autoClose) {
      this.panels.forEach((panel) => {
        if (eventTarget !== panel) {
          this.closePanel(panel);
        }
      });
    }
    eventTarget.toggle();
  }
}

versionComponent(UiAccordion);
